import { useQuery } from '@tanstack/react-query';
import apiClient from './index';

export interface RegionCount {
  code: string;
  name: string;
  count: number;
}

export interface ExportTypeCount {
  type: string;
  display: string;
  count: number;
}

export interface DashboardCampaignOption {
  id: string;
  code: string;
  name: string | null;
  label: string;
  collection_count: number;
}

export interface DashboardUsersStats {
  total: number;
  active: number;
  pending_approval: number;
  staff: number;
  new_last_30_days: number;
}

export interface AdminDashboardStats {
  computed_at: string | null;
  status: string;
  stale: boolean;
  is_staff: boolean;
  selected_campaign: string | null;
  campaigns: DashboardCampaignOption[];
  totals: {
    collections: number;
    captures: number;
  };
  platform: {
    users: DashboardUsersStats | null;
    campaigns: number;
    exports: {
      total_requests: number;
      completed: number;
      failed: number;
      in_progress: number;
      downloaded: number;
      last_30_days: number;
      unique_requesters: number;
      by_type: ExportTypeCount[];
    };
  };
  collections_by_country: RegionCount[];
  collections_by_us_state: RegionCount[];
}

export async function fetchAdminDashboardStats(
  campaignId?: string | null,
): Promise<AdminDashboardStats> {
  const params =
    campaignId && campaignId !== 'all'
      ? { campaign: campaignId }
      : undefined;
  const { data } = await apiClient.get<AdminDashboardStats>(
    '/sigcap/api/admin-dashboard-stats/',
    { params },
  );
  return data;
}

export function useAdminDashboardStats(campaignId: string | null = null) {
  const filterKey = campaignId && campaignId !== 'all' ? campaignId : 'all';
  return useQuery({
    queryKey: ['admin-dashboard-stats', filterKey],
    queryFn: () => fetchAdminDashboardStats(campaignId),
    staleTime: 60 * 1000,
    refetchInterval: 60 * 1000,
  });
}
